import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import MailOutline from "@material-ui/icons/MailOutline";
import Swal from "sweetalert2";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance"; 

import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { useNavigate } from "react-router-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { Box, CircularProgress } from "@material-ui/core";

const useStyleData = makeStyles(stylesData);
const useStyles = makeStyles(styles);

export default function AddAdmin() {
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getRoles`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRoles(res.data.role);
    } catch (err) {
      console.error(err);
      if (
        err.response?.data?.message ===
        "For security reasons, we locked your account.Please login to continue"
      ) {
        localStorage.removeItem("token");
        window.location.assign("/auth/login-page");
      } else {
        Swal.fire({
          text: err.response?.data?.message || "Something went wrong!",
        });
      }
    }
  };

  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/userManagement/viewAdmin`);
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName:"",
      email: "",
      password: "",
      confirmPassword: "",
      roleId: "",
    },

    validationSchema: Yup.object({
      firstName: Yup.string().required("Full Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      password: Yup.string().required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
      roleId: Yup.string().required("Role is required"),
    }),
    onSubmit: async (values) => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/createAdmin`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                {res.data.message}
              </span>
            }
            onConfirm={() => {
              setAlert(null);
              navigate(`/admin/userManagement/viewAdmin`); 
            }}
            onCancel={hideAlert}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={`${classesSweetAlert.button} ${classesSweetAlert.success}`}
          />
        );
      } catch (err) {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                {err.response?.data?.message || "Something went wrong!"}
              </span>
            }
            onConfirm={hideAlert}
            onCancel={hideAlert}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={`${classesSweetAlert.button} ${classesSweetAlert.error}`}
          />
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Add Managers</h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
                <Box sx={{maxWidth:"70%", margin :"0 auto" , "@media screen and (max-width:992px)":{
                    maxWidth:"100%"
                }}}>
                <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Full Name"
                    id="firstName"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: formik.values.firstName,
                    }}
                    handleChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                    helperText={formik.touched.firstName && formik.errors.firstName}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Last Name"
                    id="lastName"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: formik.values.lastName,
                    }}
                    handleChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                    helperText={formik.touched.lastName && formik.errors.lastName}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Email"
                    id="email"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      value: formik.values.email,
                    }}
                    handleChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "password",
                      value: formik.values.password,
                    }}
                    handleChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Confirm Password"
                    id="confirmPassword"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "password",
                      value: formik.values.confirmPassword,
                    }}
                    handleChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.confirmPassword &&
                      Boolean(formik.errors.confirmPassword)
                    }
                    helperText={
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                    }
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                    style={{ marginTop: "10px" }}
                  >
                    <InputLabel
                      htmlFor="roleId"
                      className={classes.selectLabel}
                    >
                      Select Role Name
                    </InputLabel>
                    <Select
                      label="Select Role Name"
                      id="roleId"
                      name="roleId"
                      value={formik.values.roleId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.roleId && Boolean(formik.errors.roleId)
                      }
                      inputProps={{
                        style: {
                          height: "30px",
                          padding: "5px 10px",
                          fontSize: "14px",
                        },
                      }}
                    >
                      {roles.map((role) => (
                        <MenuItem key={role._id} value={role._id}>
                          {role.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.roleId && formik.errors.roleId && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "10px",
                        }}
                      >
                        {formik.errors.roleId}
                      </div>
                    )}
                  </FormControl>
                </GridItem>
              </GridContainer>
              {!loading ? (
                <Button
                  color="rose"
                  type="submit"
                  className={classes.registerButton}
                >
                  Save
                </Button>
              ) : (
                <div className={classes.registerButton}>
                  <CircularProgress size={24} color="inherit" />
                </div>
              )}
                </Box>
              

              <br />

              
            </form>
          </CardBody>
        </Card>
      </GridItem>
      {alert}
    </GridContainer>
  );
}
